import axios from 'axios'

import {
  Message
} from 'element-ui'

// 创建axios的实例
const service = axios.create({
  baseURL: '/ggrc/api',
  timeout: 5000 // 请求超时时间
})

// request 拦截器
service.interceptors.request.use(
  config => {
    // 配置request 发出前的操作
    return config
  },
  error => {
    // 请求错误操作，拒绝请求
    return Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  // 处理response
  response => response,
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js